

















import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class extends Vue {
  private show = false;
  private optionList = [
    {
      name: "ManualPEAKBoard",
      icon: "far fa-file-alt",
      link:
        "https://intercom.help/peak/en/collections/3474329-%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%94%E0%B8%B9%E0%B8%A3%E0%B8%B2%E0%B8%A2%E0%B9%84%E0%B8%94-%E0%B8%84-%E0%B8%B2%E0%B9%83%E0%B8%8A-%E0%B8%88-%E0%B8%B2%E0%B8%A2%E0%B8%95%E0%B8%B2%E0%B8%A1%E0%B8%A1%E0%B8%B8%E0%B8%A1%E0%B8%A1%E0%B8%AD%E0%B8%87%E0%B8%82%E0%B8%AD%E0%B8%87%E0%B8%81%E0%B8%B4%E0%B8%88%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%9A%E0%B8%99-peak-board",
    },
    {
      name: "VideoUserManual",
      icon: "fas fa-play",
      link: "https://www.youtube.com/playlist?list=PLKx_LgGwE9YNHZx4IAYidxQtxhow62xm1",
    },
  ];

  public hide() {
    this.show = false;
  }
}
